// extracted by mini-css-extract-plugin
export default {"genericCard":"Bq-z","inline":"Cq-z","mastercard":"Dq-z","discover":"Eq-z","visa":"Fq-z","amex":"Gq-z","active":"Hq-z"};